function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query getTags {\n    Tags {\n      name\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { gql } from "graphql-request";
import { useQuery } from "./useGraphQLApi";
var GET_TAGS_QUERY = gql(_templateObject());
export var useTags = function(params) {
    var _useQuery = useQuery(GET_TAGS_QUERY, params), data = _useQuery.data, error = _useQuery.error, isValidating = _useQuery.isValidating;
    return {
        data: data,
        error: error === null || error === void 0 ? void 0 : error.message,
        loading: isValidating
    };
};

//# sourceMappingURL=useTags.js.map